let socket = null;
let currentMessageCallback = null;

export function connectRealtimeBoundaryAreaWebSocket(fid, onMessageCallback) {
    currentMessageCallback = onMessageCallback;

    // 이미 연결되어 있으면 무시
    if (socket && socket.readyState === WebSocket.OPEN) {
        console.log("✅ WebSocket already connected.");
        return;
    }

    const wsUrl = `wss://api.smartfiremon.com/ws/boundaryarea/${fid}/`;
    //const wsUrl = `wss://localhost:8000/ws/boundaryarea/${fid}/`;
    socket = new WebSocket(wsUrl);

    socket.onopen = () => {
        console.log(`🔌 WebSocket connected for fid ${fid}`);
    };

    socket.onmessage = (event) => {
        try {
            const data = JSON.parse(event.data);
            //console.log("📩 메시지 수신:", data);
            if (currentMessageCallback) currentMessageCallback(data);
        } catch (err) {
            console.error("❌ 메시지 파싱 오류:", err);
        }
    };

    socket.onerror = (err) => {
        console.error("❌ WebSocket 오류:", err);
    };

    socket.onclose = () => {
        console.warn("⚠️ WebSocket 연결 종료됨");
        socket = null; // 종료되면 다시 연결할 수 있도록 초기화
    };
}

export function disconnectWebSocket() {
    if (socket) {
        socket.close();
        socket = null;
        console.log("🔌 WebSocket 수동 종료");
    }
}
